import { Modal } from './Modal';
import { ExternalLinkIcon } from './icons';
import { PHOTO_CREDITS } from '../data/photoCredits';
import './PhotoCredits.css';

export const PhotoCredits = ({ open, onClose }) => (
  <Modal
    open={open}
    onClose={onClose}
    labelledBy="tl-credits-heading"
    closeLabel="Close photo credits"
    size="lg"
  >
    <h2 className="tl-credits__heading" id="tl-credits-heading">
      Photo credits
    </h2>
    <p className="tl-credits__intro">
      Photography on this page is licensed from Pexels and Unsplash. Attribution is not required
      under those licences — we list it for transparency.
    </p>

    <ul className="tl-credits__list">
      {PHOTO_CREDITS.map((credit) => (
        <li className="tl-credits__item" key={credit.href}>
          <p className="tl-credits__title">“{credit.title}”</p>
          <p className="tl-credits__meta">
            <a
              className="tl-credits__link"
              href={credit.href}
              target="_blank"
              rel="noopener noreferrer"
            >
              {credit.photographer} on {credit.platform}
              <ExternalLinkIcon />
              <span className="tl-visually-hidden">(opens in a new tab)</span>
            </a>
            <a
              className="tl-credits__licence"
              href={credit.licenceHref}
              target="_blank"
              rel="noopener noreferrer"
            >
              {credit.platform} licence
              <span className="tl-visually-hidden">
                {' '}
                for “{credit.title}” (opens in a new tab)
              </span>
            </a>
          </p>
        </li>
      ))}
    </ul>
  </Modal>
);
